import { LocationStrategy } from "@angular/common";
import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { AlineacionImagenEnum } from "@componentes/Enums.enum";
import { EvaluacionComponent } from "@contenido/AppContent/global/evaluacion/evaluacion.component";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum, DialogoEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { EvaluacionAlumno } from "@modelo/global/EvaluacionAlumno.model";
import { EvaluacionPendienteVisualizacion } from "@modelo/proceso/evaluacionpendientevisualizacion.model";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component(
    {
        selector: 'evaluacionpendienteprevisualizaralumno',
        templateUrl: './previsualizar_alumno.component.html',
        styleUrls: ['./previsualizar_alumno.component.scss']
    })

    export class EvaluacionPendientePrevisualizarAlumnoComponent implements AfterViewInit{

        consulta!: boolean;
        @Input() metodoevaluacion!: number;
        @Input() entidad!: EvaluacionAlumno;
        titulo!: string;
        @Output() output = new EventEmitter();

        visualizacion: EvaluacionPendienteVisualizacion;
        cantidaddeevaluaciones:any[] = [];
        cantidadevaluacion: number = 0;

        listapreguntas: any;
        objobservacion: any;

        @ViewChild('datosDesdeElPadre') private evaluacion!: EvaluacionComponent;

        public AlineacionImagenEnum = AlineacionImagenEnum;
        constructor(private appService: AppService, private location: LocationStrategy, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver){
            this.entidad = new EvaluacionAlumno();
            this.visualizacion = new EvaluacionPendienteVisualizacion();
            this.listapreguntas = [];
        }

        ngAfterViewInit() {
            this.SetPreguntas();
        }

    SetPreguntas() {
        this.appService.Post("planeacion/asignacionevaluacion/previsualizaralumno", this.entidad).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.objobservacion = res.data.observacion[0];
                this.visualizacion = new EvaluacionPendienteVisualizacion(res.data.visualizacion);
                    if(this.visualizacion.tipovisualizacionrespuestaid == 2){
                        this.listapreguntas = res.data.pregunta;
                         if(this.listapreguntas.length == 0){
                            this.listapreguntas = [];
                            this.mensajeService.Alerta(AlertaEnum.Warning, "Esta evaluación no tinene preguntas, por favor comunícate con un administrador");
                            this.output.next();
                        }else{
                            this.listapreguntas.map((pregunta:any)=>{
                                pregunta.colortext = this.cambiarcolor(pregunta.color);
                            })
                        }
                    }else{
                        this.cantidaddeevaluaciones = res.data.pregunta;
                        this.listapreguntas = this.cantidaddeevaluaciones[this.cantidadevaluacion];
                        if(!this.listapreguntas){
                            this.listapreguntas = [];
                            this.mensajeService.Alerta(AlertaEnum.Warning, "Este Alumno no tiene ninguna evaluación, por favor comunícate con un administrador");
                            this.output.next();
                        }
                    }
            }else{
                this.output.next();
            }
        }).catch(err =>{
            this.output.next();
        })
    }

    empezarencuesta(){
        let opciones = this.sistemaService.GetOpcionesSalirEvaluacion();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'A completado todas las evaluaciones.<br> de click en salir para cerrar la evaluación', opciones).then(res => {
            if (res == 1) {
                this.consulta = true;
                this.output.next(this.consulta);
            }
        });
    }

    cambiarcolor(color: any): string {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
        let val: any = [];
        if (result) {
            let r = parseInt(result[1], 16)
            let g = parseInt(result[2], 16)
            let b = parseInt(result[3], 16)
            val = this.rgbToHsl(r, g, b);
        }
        if (val[2] < 50) {
            return "colorblanco"
        } else {

            return "colornegro";
        }
    }

    rgbToHsl(r: any, g: any, b: any) {
        r /= 255;
        g /= 255;
        b /= 255;

        // Find greatest and smallest channel values
        let cmin = Math.min(r, g, b),
            cmax = Math.max(r, g, b),
            delta = cmax - cmin,
            h = 0,
            s = 0,
            l = 0;

        // Calculate hue
        // No difference
        if (delta == 0)
            h = 0;
        // Red is max
        else if (cmax == r)
            h = ((g - b) / delta) % 6;
        // Green is max
        else if (cmax == g)
            h = (b - r) / delta + 2;
        // Blue is max
        else
            h = (r - g) / delta + 4;

        h = Math.round(h * 60);

        // Make negative hues positive behind 360°
        if (h < 0)
            h += 360;

        // Calculate lightness
        l = (cmax + cmin) / 2;

        // Calculate saturation
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

        // Multiply l and s by 100
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);

        return [h, s, l];
    }

        Salir() {
            this.output.next();
        }
    }
